import {AppPermissionId, EnnablUserViewMode} from 'modules/decisionsNext/api/types';

import {
  ENNABL_COMMAND,
  ENNABL_DECISIONS,
  ENNABL_GROWTH,
  ENNABL_MGA_DASHBOARD,
  ENNABL_SETTINGS,
  ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD,
  ENNABL_SETTINGS_DATA_MANAGEMENT_USER,
  ENNABL_WORKFLOWS,
} from 'core/constants/paths';
import {useAppPermissions, useFeatureFlag, useIsMgaDashboard, useIsProducer, useUserInfo} from 'core/hooks/authHooks';
import {FeatureFlags} from 'core/constants/featureFlags';
import {neverCase} from 'utils/misc';
import {useEntityAccess} from 'core/hooks/useEntityAccess';
import {useIsSourceDataExists} from 'core/hooks/useIsSourceDataExists';

const useDefaultRouteOld = () => {
  const {hasPermission} = useAppPermissions();
  const isMGADashboard = useIsMgaDashboard();
  const isGrowthProducer = useIsProducer();

  if (isMGADashboard) {
    return ENNABL_MGA_DASHBOARD;
  }

  if (hasPermission(AppPermissionId.OnlyDocuments)) {
    return ENNABL_WORKFLOWS;
  }

  if (hasPermission(AppPermissionId.OnlyReportStudio)) {
    return ENNABL_DECISIONS;
  }

  if (isGrowthProducer) {
    return ENNABL_GROWTH;
  }

  if (hasPermission(AppPermissionId.ViewDecisions)) {
    return ENNABL_DECISIONS;
  }

  if (hasPermission(AppPermissionId.EditCommand)) {
    return ENNABL_COMMAND;
  }

  return '/';
};

// TODO: Refactor when all tenants are migrated to new permissions
export const useDefaultRoute = () => {
  const withNewPermissions = useFeatureFlag(FeatureFlags.UserManagement);
  const {role} = useUserInfo();
  const defaultRouteOld = useDefaultRouteOld();
  const {withUserManagementOnly, withDataManagementOnly} = useEntityAccess();
  const {isSourceDataExists} = useIsSourceDataExists();

  if (!withNewPermissions || !role) {
    return defaultRouteOld;
  }

  if (withDataManagementOnly) {
    return isSourceDataExists ? ENNABL_SETTINGS_DATA_MANAGEMENT_USER : ENNABL_SETTINGS_DATA_MANAGEMENT_UPLOAD;
  }

  if (withUserManagementOnly) {
    return ENNABL_SETTINGS;
  }

  // ViewMode = MgaDefault but FF is off = DecisionsDefault
  if (!role.viewMode) {
    return ENNABL_DECISIONS;
  }

  switch (role.viewMode) {
    case EnnablUserViewMode.DecisionsDefault:
    case EnnablUserViewMode.DecisionsAccountManager:
      return ENNABL_DECISIONS;

    case EnnablUserViewMode.DecisionsProducer:
      return ENNABL_GROWTH;

    case EnnablUserViewMode.MgaDefault:
      return ENNABL_MGA_DASHBOARD;

    case EnnablUserViewMode.EnnablData:
      return ENNABL_COMMAND;

    default:
      return neverCase(role.viewMode);
  }
};
